import { theme } from '@noths/polaris-client-ribbons-base';
import { shadowDown } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

import { DRAWER_HEADER_TITLE_CLASSNAME } from '../constants/classNames';

export const header = css`
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  padding: 24px 16px;
  ${shadowDown};
  background-color: var(--neutral-white-base);

  .${DRAWER_HEADER_TITLE_CLASSNAME} {
    ${theme.responsiveText.HEADING.SM};
    margin: 0;
  }
`;

export const backBtn = css`
  margin-right: 18px;
`;

export const closeBtn = css`
  margin-left: auto;
`;
